import { hydrate } from 'svelte'

import createHomeStores from '../stores/createHomeStores'

import AnimatedValue from '../../components/projects/facts-and-figures/core/dataviz/AnimatedValue.svelte'
import DecorativeDonut from '../../components/projects/facts-and-figures/composite/DecorativeDonut.svelte'
import DecorativeHorizontalBars from '../../components/projects/facts-and-figures/composite/DecorativeHorizontalBars.svelte'
import LabelValueParagraph from '../../components/projects/facts-and-figures/core/visual/LabelValueParagraph.svelte'
import OpenBottomDonut from '../../components/projects/facts-and-figures/composite/OpenBottomDonut.svelte'
import SoloBarChart from '../../components/projects/facts-and-figures/composite/SoloBarChart.svelte'
import StandardDonut from '../../components/projects/facts-and-figures/composite/StandardDonut.svelte'
import ThreeColList from '../../components/projects/facts-and-figures/core/ThreeColList.svelte'
import GenericDonut from '../../components/projects/facts-and-figures/highcharts/GenericDonut.svelte'
import PressGaneyDounut from '../../components/projects/facts-and-figures/composite/PressGaneyDonut.svelte'

// import Test from '../../components/projects/facts-and-figures/util/Test.svelte'
// import Home from '../../components/projects/facts-and-figures/_demo/pages/Home.svelte'

const regex = /\$|\,/g

/**
 * Fetch data for Home; Mount home components with data
 */
export default function () {
  // createHomeStores() creates and returns a whole bunch of stores that we load in here
  const [
    data, // the main store; will hold ALL data fetched
    loading, // will be true until the data fetching is done, can be used in components for loading state
    error, // if the fetches went completely sideways, this will be truthy, and can be used in components
    
    facultyEndowmentDerived,
    facultyOneYearDerived,
    facultyPrincipleDerived,
    holdingsDerivedAndDivided,
    holdingsDerived,
    outpatientDerivedAndDivided,
    outpatientDerived,
    pharmaDerived,
    studentByDegreeDerived, 
    totalAnnualDerived,
    totalFacultyDerived, 
    totalEducationDerived,
  ] = createHomeStores()

  if(document.getElementById('faculty-endowment')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('faculty-endowment'),
      props: {
        // value: Number(Object.values(inboundData.facultyEndowment.data.data)[0]),
        store: facultyEndowmentDerived
      }
    })

    // new AnimatedValue({
    //   target: document.getElementById('faculty-endowment'),
    //   hydrate: true,
    //   props: {
    //     // value: Number(Object.values(inboundData.facultyEndowment.data.data)[0]),
    //     store: facultyEndowmentDerived
    //   }
    // })
  }

  if(document.getElementById('faculty-principle')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('faculty-principle'),
      props: {
        prefix: '$',
        store: facultyPrincipleDerived,
      }
    })

    // new AnimatedValue({
    //   target: document.getElementById('faculty-principle'),
    //   hydrate: true,
    //   props: {
    //     prefix: '$',
    //     store: facultyPrincipleDerived,
    //   }
    // })
  }

  if(document.getElementById('fac-miss-bars')) {
    hydrate(SoloBarChart, {
      target: document.getElementById('fac-miss-bars'),
      props: {
        store: totalFacultyDerived
      }
    })
    // mount(SoloBarChart, {
    //   target: document.getElementById('fac-miss-bars'),
    //   props: {
    //     store: totalFacultyDerived
    //   }
    // })
  }

  if(document.getElementById('edu-red-bars')) {
    hydrate(SoloBarChart, {
      target: document.getElementById('edu-red-bars'),
      props: {
        variant: 'base',
        store: studentByDegreeDerived
      }
    })
    // mount(SoloBarChart, {
    //   target: document.getElementById('edu-red-bars'),
    //   props: {
    //     variant: 'base',
    //     store: studentByDegreeDerived
    //   }
    // })
  }

  if(document.getElementById('home-faculty')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('home-faculty'),
      props: {
        // value: Math.round(Number(Object.values(inboundData.facultyOneYear.data.data)[0].replace(regex, ""))/1000)*1000
        store: facultyOneYearDerived
      }
    })
    // new AnimatedValue({
    //   target: document.getElementById('home-faculty'),
    //   props: {
    //     // value: Math.round(Number(Object.values(inboundData.facultyOneYear.data.data)[0].replace(regex, ""))/1000)*1000
    //     store: facultyOneYearDerived
    //   }
    // })
  }

  if(document.getElementById('total-outpatient-visits')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('total-outpatient-visits'),
      props: {
        store: totalAnnualDerived
      }
    })

    // new AnimatedValue({
    //   target: document.getElementById('total-outpatient-visits'),
    //   hydrate: true,
    //   props: {
    //     store: totalAnnualDerived
    //   }
    // })
  }

  if(document.getElementById('home-clinical')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('home-clinical'),
      props: {
        // value: Number(Object.values(inboundData.outpatient.data.data)[0])/1000000,
        store: outpatientDerivedAndDivided,
        numberOfDecimals: 1,
        suffix:'M'
      }
    })
    // new AnimatedValue({
    //   target: document.getElementById('home-clinical'),
    //   hydrate: true,
    //   props: {
    //     // value: Number(Object.values(inboundData.outpatient.data.data)[0])/1000000,
    //     store: outpatientDerivedAndDivided,
    //     numberOfDecimals: 1,
    //     suffix:'M'
    //   }
    // })
  }

  if(document.getElementById('home-research')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('home-research'),
      props: {
        // value:Number(Object.values(inboundData.holdings.data.data)[0].replace(regex, ""))/1000000,
        store: holdingsDerivedAndDivided,
        prefix: '$',
        suffix: 'M'
      }
    })
    // new AnimatedValue({
    //   target: document.getElementById('home-research'),
    //     hydrate: true,
    //   props: {
    //     // value:Number(Object.values(inboundData.holdings.data.data)[0].replace(regex, ""))/1000000,
    //     store: holdingsDerivedAndDivided,
    //     prefix: '$',
    //     suffix: 'M'
    //   }
    // })
  }

  if(document.getElementById('total-annual-visits')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('total-annual-visits'),
      props: {
        // value: Number(Object.values(inboundData.totalAnnual.data.data)[0])
        store: outpatientDerived
      }
    })
    // new AnimatedValue({
    //   target: document.getElementById('total-annual-visits'),
    //   hydrate: true,
    //   props: {
    //     // value: Number(Object.values(inboundData.totalAnnual.data.data)[0])
    //     store: outpatientDerived
    //   }
    // })
  }

  if(document.getElementById('grant-expenditures')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('grant-expenditures'),
      props: {
      prefix: '$',
        // value: Number(Object.values(inboundData.pharma.data.data)[0].replace(regex, "")),
        store: pharmaDerived
        // isMoney: true
      }
    })
  }

  if(document.getElementById('grant-contract-holdings')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('grant-contract-holdings'),
      props: {
      prefix: '$',
        // value: Number(Object.values(inboundData.holdings.data.data)[0].replace(regex, "")),
        store: holdingsDerived
      }
    }) 
  }

  if(document.getElementById('edu-total')) {
    hydrate(AnimatedValue, {
      target: document.getElementById('edu-total'),
      props: {
        store: totalEducationDerived,
      }
    })
  }

  if(document.getElementById('edu-donut')) {
    hydrate(DecorativeDonut, {
      target: document.getElementById('edu-donut'),
      props: {
        store: totalEducationDerived,
      }
    })
  }
}